import React, { useContext, useEffect } from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";

// core components
import Slider from "./Slider";
import StaticContent from "../components/AC-StaticPages/StaticContent.jsx";

import { I18nContext } from "../i18n/index";

function Main(props) {
  const dispatch = useDispatch();
  const { langCode } = useContext(I18nContext);

  const isMobileState = useSelector(
    state => state.mainReducer.isMobile,
    shallowEqual
  );

  const navCatsState = useSelector(
    state => state.menuReducer.navCats,
    shallowEqual
  );

  if (props.component === "staticContent") {
    return (
      <React.Fragment>
        <div id="bd">
          <StaticContent />
        </div>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div id="bd">
          <div className="item">
            <div style={{ padding: "unset" }}>
              <div id="slide">
                <div className="slideshow-container">
                  <Slider />
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Main;
